import { replace } from "connected-react-router";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'select' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { all, call, put, select, takeEvery } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { EventPlace, pushDataLayerEvent, trackEngagement } from "helpers/analytics";
import { pushWithUTM } from "helpers/sagas";
import { AutomationsRoutes } from "routes/automations/constants";
import { ApiManager } from "services/api";
import * as RuleSerializer from "services/api/rules/rule-serializer";
import { BrowserHistory } from "services/browser-history";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { IEntityUpdateFailure, RequestAction } from "../actions";

import { RulesActions, RulesActionsNames } from "./actions";
import {
  IRuleCreateFailurePayload,
  IRuleCreatePayload,
  IRuleCreateSuccessPayload,
  IRuleDeletePayload,
  IRuleDeleteSuccessPayload,
  IRuleFetchPayload,
  IRuleUpdatePayload,
  IRuleUpdateSuccessPayload,
} from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchRule(action: IActionWithPayload<string, IRuleFetchPayload>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.ruleApi.fetch, id);

  if (response.result) {
    yield put(RulesActions.fetchSuccess({ id, value: RuleSerializer.deserializeRule(response.result) }));
  } else {
    yield put(RulesActions.fetchFailure({ id, error: response.error }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateRule(action: IActionWithPayload<string, IRuleUpdatePayload>) {
  const { id, ...rest } = action.payload.value;
  const { activeChange } = action.payload;

  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.ruleApi.update, id, rest);

  if (response.result) {
    const rule = RuleSerializer.deserializeRule(response.result);

    yield put(
      RulesActions.updateSuccess({
        id,
        value: rule,
        activeChange,
      } as IRuleUpdateSuccessPayload)
    );
  } else {
    yield put(
      // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      RulesActions.updateFailure({ id, error: response.error.error.message, errorObject: response.error.error })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createRule(action: IActionWithPayload<string, IRuleCreatePayload>) {
  const { value, duplicated, fromTemplate } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.ruleApi.create, value);

  if (response.result) {
    const rule = RuleSerializer.deserializeRule(response.result);

    yield put(RulesActions.createSuccess({ id: response.result.ID, value: rule, duplicated, fromTemplate }));
  } else {
    yield put(
      RulesActions.createFailure({ error: response.error.error.message, errorObject: response.error.error, duplicated })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteRule(action: IActionWithPayload<string, IRuleDeletePayload>) {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.ruleApi.remove, action.payload.id);

  if (response.result) {
    yield put(RulesActions.deleteSuccess({ id: action.payload.id }));
  } else {
    yield put(RulesActions.deleteFailure({ id: action.payload.id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchRules() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.ruleApi.fetchAll);

  if (response.result) {
    yield put(
      RulesActions.fetchCollectionSuccess({
        values: response.result.map(RuleSerializer.deserializeRule),
      })
    );
  } else {
    yield put(
      RulesActions.fetchCollectionFailure({
        error: response.error,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createRuleSuccess(action: IActionWithPayload<string, IRuleCreateSuccessPayload>) {
  const { duplicated, fromTemplate, value } = action.payload;
  const currentRoute = BrowserHistory.pathname;
  if (currentRoute === AutomationsRoutes.AddRule) {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    yield put(replace(`${AutomationsRoutes.Rules}/#${value.id}`));
  }

  if (duplicated && currentRoute === AutomationsRoutes.Rules) {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    yield put(pushWithUTM(`${AutomationsRoutes.EditRule}/${value.id}`));
  }

  if (duplicated) {
    yield call(trackEngagement, "Workflows: Workflow duplicated", EventPlace.Settings, {
      fromWorkflowId: duplicated,
      duplicatedWorkflowId: value?.id,
      actions: value?.actions,
      triggers: value?.triggers,
    });
    yield call(pushDataLayerEvent, "Workflows: Workflow duplicated");
  } else if (fromTemplate) {
    yield call(trackEngagement, "Workflows: Pre-made workflow created", EventPlace.Settings, {
      workflowId: value?.id,
      premadeType: fromTemplate,
      actions: value?.actions,
      triggers: value?.triggers,
    });
    yield call(pushDataLayerEvent, "Workflows: Pre-made workflow created");
  } else {
    yield call(trackEngagement, "Workflows: Custom workflow created", EventPlace.Settings, {
      workflowId: value?.id,
      actions: value?.actions,
      triggers: value?.triggers,
    });
    yield call(pushDataLayerEvent, "Workflows: Custom workflow created");
  }

  yield put(
    ToastsActions.createToast({
      variant: ToastVariant.Success,
      content: getToastContent(ToastContent.RULE_CREATE_SUCCESS, { duplicated }),
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateRuleSuccess(action: IActionWithPayload<string, IRuleUpdateSuccessPayload>) {
  if (action.payload.activeChange && !action.payload.value?.active) {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.RULE_INACTIVE_SUCCESS),
      })
    );
    yield call(trackEngagement, "Workflows: Workflow deactivated", EventPlace.Settings, {
      workflowId: action.payload.value?.id,
    });
  } else if (action.payload.activeChange && action.payload.value?.active) {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.RULE_ACTIVE_SUCCESS),
      })
    );
    yield call(trackEngagement, "Workflows: Workflow activated", EventPlace.Settings, {
      workflowId: action.payload.value?.id,
    });
  } else {
    const currentRoute = BrowserHistory.pathname;
    if (currentRoute.startsWith(`${AutomationsRoutes.Rules}/edit`)) {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      yield put(replace(`${AutomationsRoutes.Rules}/#${action.payload.value.id}`));
    }

    yield call(trackEngagement, "Workflows: Workflow updated", EventPlace.Settings, {
      workflowId: action.payload.value?.id,
    });

    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.RULE_UPDATE_SUCCESS),
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteRuleSuccess(action: IActionWithPayload<string, IRuleDeleteSuccessPayload>) {
  yield call(trackEngagement, "Workflows: Workflow deleted", EventPlace.Settings, {
    workflowId: action.payload.id,
  });

  yield put(
    ToastsActions.createToast({
      variant: ToastVariant.Success,
      content: getToastContent(ToastContent.RULE_DELETE_SUCCESS),
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createRuleFailure(action: IActionWithPayload<string, IRuleCreateFailurePayload>) {
  const { duplicated, errorObject } = action.payload;

  yield put(
    ToastsActions.createToast({
      variant: ToastVariant.Error,
      content: getToastContent(ToastContent.RULE_CREATE_FAILURE, { duplicated, type: errorObject?.type }),
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateRuleFailure(action: IActionWithPayload<string, IEntityUpdateFailure>) {
  const { errorObject } = action.payload;

  yield put(
    ToastsActions.createToast({
      variant: ToastVariant.Error,
      content: getToastContent(ToastContent.RULE_UPDATE_FAILURE, { type: errorObject?.type }),
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteRuleFailure() {
  yield put(
    ToastsActions.createToast({
      variant: ToastVariant.Error,
      content: getToastContent(ToastContent.RULE_DELETE_FAILURE),
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* rulesSagas() {
  yield all([
    takeEvery(RulesActionsNames.FETCH_SINGLE[RequestAction.REQUEST], fetchRule),
    takeEvery(RulesActionsNames.FETCH_COLLECTION[RequestAction.REQUEST], fetchRules),
    takeEvery(RulesActionsNames.UPDATE[RequestAction.REQUEST], updateRule),
    takeEvery(RulesActionsNames.CREATE[RequestAction.REQUEST], createRule),
    takeEvery(RulesActionsNames.DELETE[RequestAction.REQUEST], deleteRule),
    takeEvery(RulesActionsNames.UPDATE[RequestAction.SUCCESS], updateRuleSuccess),
    takeEvery(RulesActionsNames.CREATE[RequestAction.SUCCESS], createRuleSuccess),
    takeEvery(RulesActionsNames.DELETE[RequestAction.SUCCESS], deleteRuleSuccess),
    takeEvery(RulesActionsNames.UPDATE[RequestAction.FAILURE], updateRuleFailure),
    takeEvery(RulesActionsNames.CREATE[RequestAction.FAILURE], createRuleFailure),
    takeEvery(RulesActionsNames.DELETE[RequestAction.FAILURE], deleteRuleFailure),
  ]);
}
